import * as coreEntities from 'core/store/index';
import { isTeacher } from 'core/utils/user';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Despacha las acciones Redux que rehidratan los slices persistidos
 * (`programs`, `courses`, `teacherCourses`, `groups`) tras canjear una
 * licencia. Sin esto, los selectores siguen sirviendo el snapshot persistido
 * obsoleto hasta el siguiente logout/login.
 */
export function useRefreshUserContent() {
  const dispatch = useDispatch();
  const user = useSelector((state) => coreEntities.auth.selectors.getUser(state));

  return function refreshUserContent() {
    dispatch(coreEntities.programs.actions.getPrograms({ isBook: 1, orderBy: 't.name + asc ' }));
    dispatch(coreEntities.courses.actions.getCourses({ params: { offset: 0, pageSize: 1000 } }));
    dispatch(coreEntities.courses.actions.getTeacherCourses());
    if (isTeacher(user) && user?.schools?.[0]?.guid) {
      dispatch(
        coreEntities.groups.actions.getGroups({
          params: { offset: 0, pageSize: 1000, schoolGuid: user.schools[0].guid, orderBy: 'created_at desc', members: 'all' },
        })
      );
    }
  };
}
